import React from "react";
import { useState } from 'react';
import './Computadoras.css';
import imgLaptop from '../../assets/images/laptopcatalogo.jpg';
import imgDesktop from '../../assets/images/desktopcatalogo2.png';
import imgAllInOne from '../../assets/images/allinonecatalogo1.avif';
import imgUltrabook from '../../assets/images/ultrabookcatalogo1.png';
import imgChromebook from '../../assets/images/chromebookcatalogo2.webp';
import imgWorkstation from '../../assets/images/workstationcatalogo1.png';
import Facebok from '../../assets/images/Facebok.png';
import Wasa from '../../assets/images/Wasa.png';
import insta from '../../assets/images/insta.png';
import Ubi from '../../assets/images/Ubi.png';
import Telefono from '../../assets/images/Telefono.png';
import Email34 from '../../assets/images/Correo.png';
import checkAnim from '../../assets/images/check.gif';
import RedesFondo from '../../assets/images/Red-Neuronal.png';

import { FaWhatsapp } from 'react-icons/fa';
{/* Bloque de menú catalogo Computación*/}
const categorias = [
  {
    //Item 1 catalogo Computación 
    titulo: 'Laptops / Notebooks',
    img: imgLaptop,
    marcas: ['HP', 'Dell', 'Lenovo', 'Acer', 'Asus'],
  },
  {
    //Item 2 catalogo Computación 
    titulo: 'PCs de Escritorio',
    img: imgDesktop,
    marcas: ['HP', 'Dell', 'Lenovo', 'MSI', 'XtremePC'],
  },
  {
    //Item 3 catalogo Computación 
    titulo: 'All-in-One (Todo en Uno)',
    img: imgAllInOne,
    marcas: ['HP', 'Lenovo', 'Asus', 'Dell'],
  },
  {
    //Item 4 catalogo Computación 
    titulo: 'Ultrabooks',
    img: imgUltrabook,
    marcas: ['Dell XPS', 'HP Spectre', 'ASUS ZenBook'],
  },
  {
    //Item 5 catalogo Computación 
    titulo: 'Chromebooks',
    img: imgChromebook,
    marcas: ['Acer', 'HP', 'Lenovo', 'Samsung'],
  },
  {
    //Item 6 catalogo Computación 
    titulo: 'Workstations',
    img: imgWorkstation,
    marcas: ['Dell Precision', 'HP Z', 'Lenovo ThinkStation'],
  },
];


function ComputadorasCatalogo() {

    const [enviado, setEnviado] = useState(false);
    
      const handleSubmit = (e) => {
        e.preventDefault();
        const form = e.target;
    
        fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
        }).then(() => {
          setEnviado(true);
          form.reset();
          // Opcional: volver a mostrar formulario después de 5s
          // setTimeout(() => setEnviado(false), 5000);
        });
      };
  return (
    <>
    {/* Bloque de inicio catalogo Computación*/}
  <section className="extra-white-section2">
   <div className="catalogo-header">
    {/*Titulo de catalogo Computación */}
    <h2 className="catalogo-titulo">Equipos de Cómputo</h2>

    <div className="catalogo-texto-lateral">
      {/*Descripción catalogo Computación */}
      <p className="catalogo-contacto-descripcion">
        Equipos originales, de marcas reconocidas y con garantía.
      </p>
    </div>
    </div>

  <div className="catalogo-grid">
    {categorias.map((cat, idx) => (
      <div className="catalogo-item" key={idx}>
        <div className="catalogo-img">
          <img src={cat.img} alt={cat.titulo} />
        </div>
        <div className="catalogo-texto">
          <h3>{cat.titulo}</h3>
         <p className="catalogo-marcas">
  {cat.marcas.map((marca, i) => (
    <span key={i} className="marca-texto">
      {marca}
    </span>
  ))}
</p>
          
        </div>
      </div>
    ))}
  </div>
  {/*Sugerencia whatsapp catalogo Computación */}
<p className="catalogo-contacto">
        ¿Buscas un equipo en específico? Podemos conseguirlo.<br />
         &nbsp;&nbsp;&nbsp;&nbsp;Ponte en contacto con{' '}
        <a
          href="https://wa.me/525567786252"
          target="_blank"
          rel="noopener noreferrer"
          className="whatsapp-link"
        >
          nosotros <FaWhatsapp className="whatsapp-icon-inline" />
        </a>
      </p>
</section>
      {/* Contenedor principal del formulario de contacto */}
 <div className="formulario-imagen-style20">
  <div className="linea-superior20"></div>

  {/*Titulo Formulario*/}
  <h2>
    {/*Titulo cambiado formulario catalogo Computación */}
  {!enviado ? (
    'Elige tu equipo ideal. ¡Cotiza ahora!'
  ) : (
    <>
      ¡¡¡ GRACIAS POR CONTACTARNOS !!!<br />
        Un especialista se pondrá en contacto contigo.
    </>
  )}
</h2>

  {!enviado ? (
    <form
      onSubmit={handleSubmit}
      action="https://formsubmit.co/ivan.benitez@iatekza.com"
      method="POST"
      className="formulario-simple20"
    >
      <input type="hidden" name="_captcha" value="false" />
{/* Campos de entrada para nombre, teléfono, correo, empresa y mensaje */}

      {/* Campo nombre*/}
      <input type="text" name="nombre" placeholder="Nombre" required />
      {/* Campo  Numero Telefonico*/}
      <input type="tel" name="numero" placeholder="Número Telefónico" required />
      {/* Campo Correo Electronico*/}
      <input type="email" name="correo" placeholder="Correo Electrónico" required />
      {/* Campo Empresa*/}
      <input type="text" name="empresa" placeholder="Empresa (Opcional)" />
      {/* Campo Mensaje*/}
      <textarea name="mensaje" placeholder="Mensaje" required></textarea>
      {/* Botón de envío del formulario */}
      <button type="submit">Enviar</button>
    </form>
  ) : (
    <div className="confirmacion-envio20">
      <img src={checkAnim} alt="Éxito" />
      <p>¡ Mensaje enviado correctamente !</p>
    </div>
  )}
</div>



{/* Contenedor principal  de pie de pagina con contacto*/}
<div className="contacto-footer-nuevo">
  <div className="footer-contenido-nuevo">
    {/* Fondo completo con redes */}
  <img src={RedesFondo} alt="Fondo redes" className="redes-fondo-completa" />
    {/* Columna 1: Contacto */}
    <div className="footer-columna-nueva">
  <h4>CONTACTO GRUPO IATEKZA</h4>

  <div className="footer-item">
    <img src={Ubi} alt="Ubi" className="footer-icono" />
    <p>Circon 5, Colonia El Pedregal de <br /> Atizapán, Estado de México, C.P. 52948.</p>
  </div>

  <div className="footer-item">
    <img src={Telefono} alt="Teléfono" className="footer-icono" />
    <p>+52 55 5335 5810</p>
  </div>

  <div className="footer-item">
    <img src={Email34} alt="Correo" className="footer-icono" />
    <p>ventas@iatekza.com</p>
  </div>
</div>


    {/* Columna 2: Servicios */}
    <div className="footer-columna-nueva">
      <h4>Conoce nuestros servicios</h4>
      <ul>
        {/* Servicio Consultoria ERP LIBRA colum 2*/}
        <li><a href="/Comercializacion">• Ver mas Infraestructura TI</a></li>
        <li><a href="/">• IAutomatizacion CFDI</a></li>
         
        <li><a href="/Facturacion">• Facturación Electrónica</a></li>
        <li><a href="/Consultoria">• Asesoría Empresarial</a></li>
        {/* Servicio Sistemas colum 2*/}
        <li><a href="/Sistemas">• Soluciones Tecnologícas</a></li>
      </ul>
      {/*Facebook Colum 2*/}
      <div className="iconos-redes-nuevos">
        <a href="https://www.facebook.com/profile.php?id=61577085653032&locale=es_LA/" target="_blank" rel="noopener noreferrer">
          <img src={Facebok} alt="Facebook" />
        </a>
        {/*Wasak Colum 2*/}
        <a href="https://api.whatsapp.com/send?phone=5215567786252&text=Hola, me gustaría más información acerca de:" target="_blank" rel="noopener noreferrer">
          <img src={Wasa} alt="WhatsApp" />
        </a>
        {/*Instagram Colum 2*/}
        <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
          <img src={insta} alt="Instagram" />
        </a>
      </div>
    </div>

    {/* Columna 3: Información general */}
    <div className="footer-columna-nueva">
      <h4>Información General</h4>
      <ul>
         {/*Sobre Nostros Colum 3*/}
        <li><a href="/Nosotros">Sobre nosotros</a></li>
         {/*Casos de Exito Colum 3*/}
        <li><a href="/CasosExito">Casos de Éxito</a></li>
         {/*Facturacion Electronica Colum 3*/}
        {/*Servicios Colum 3*/}
        <li><a href="/Legal">Aviso Legal</a></li>
      </ul>
    </div>
  </div>

{/* Línea de derechos reservados */}
  <div className="footer-bottom-nuevo">
    <p>© Grupo IAtekza 2025 – Todos los derechos reservados</p>
  </div>
</div>

<a
  href="https://wa.me/525567786252"
  target="_blank"
  rel="noopener noreferrer"
  className="whatsapp-bubble"
>
  <FaWhatsapp size={35} color="#fff" />
</a>

</>

  );
}

export default ComputadorasCatalogo;
